import { FormAttendanceFlagsModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class AttendanceFlagsEditor extends AbstractElementEditor<FormAttendanceFlagsModel> {
  public getDescription(): string {
    return 'Attendance Flags';
  }

  public getName(): string {
    return 'Attendance Flags';
  }

  public getIcon(): string {
    return 'flag';
  }
}
